import { TSortableColumn } from '../Components/GenericTable/types';

export const candidatesTableColumn: TSortableColumn[] = [
  {
    id: 'id',
    label: 'ID',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'name',
    label: 'Name',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'sources',
    label: 'Sources',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'emails',
    label: 'Emails',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'phones',
    label: 'Phones',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'pools',
    label: 'Pools',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'matching_percent',
    label: 'Matching Percent',
    sortable: false,
    canToggle: false,
    enabled: true
  }
];
